<template>
  <div class="container-fluid">
    <div class="row kv">
      <div class="offset-md-6 col-md-4">
        <div class="kv__info">
          <h2 v-html="$t('kv.t1')"></h2>
          <h4 v-html="$t('kv.t2')"></h4>
          <img class="mt-4 img-fluid" src="@/assets/images/kv-prods.png" alt="">
          <div class="mt-4">
            <router-link v-html="$t('kv.button')" class="register-btn" :to="'/product-registration'"></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Kv'
  }
</script>

<style lang="scss" scoped>
  .kv {
    height: 578px;
    background: url('../../assets/images/kv.jpg');
    background-position: 50% 50%;

    @media only screen and (max-width : 768px) {
      background: #f6f6f6;
      height: auto;
      padding-top: 30px;
      padding-bottom: 30px;
      text-align: center;
    }
    // @media only screen and (max-width : 991px) {
    // }

    .kv__info {
      margin-top: 120px;
      margin-left: calc((100vw / 12) / 2); // 1/2grid

      @media only screen and (max-width : 768px) {
        margin-top: 0px;
      }
      
      h2 {
        font-size: 42px;
        font-weight: 700;
        color: #fff;

        @media only screen and (max-width : 991px) {
          font-size: 34px;
        }
      }

      h4 {
        font-size: 30px;
        color: #fff;

        @media only screen and (max-width : 991px) {
          font-size: 24px;
        }
      }

      a.register-btn {
        background: #fff;
        border-radius: 99px;
        color: #e41429;
        font-size: 16px;
        font-weight: 400;
        padding: 10px 40px;
        display: inline-block;
        text-align: center; 
        
        &:hover {
          background: darken(#fff, 10%);
          text-decoration: none;
        }
      }
    }
  }
</style>
